import { Scarcity } from "fungi-types";
import { getCardLevel } from "./cardXp";

export const getCardBonus = (input: {
  xp: number;
  scarcity: Scarcity;
  season: string | number;
}) => {
  const cardLevel = getCardLevel(input.xp);
  const scarcityBonus = getScarcityBonus(input.scarcity);
  const seasonBonus = getSeasonBonus(input.season);

  return {
    level: cardLevel.bonus,
    scarcity: scarcityBonus,
    season: seasonBonus,
    total: cardLevel.bonus + scarcityBonus + seasonBonus,
  };
};

const getScarcityBonus = (scarcity: Scarcity) => {
  switch (scarcity) {
    case Scarcity.SILVER:
      return 5;
    case Scarcity.GOLD:
      return 10;
    case Scarcity.PLATINUM:
      return 15;
    default:
      return 0;
  }
};

const getSeasonBonus = (season: string | number) => {
  const now = new Date();
  const currentYear = 2026;
  const seasonNumber =
    typeof season === "string" ? parseInt(season, 10) : season;

  // If it's current year or future, 5% bonus
  if (seasonNumber >= currentYear) {
    return 5;
  }

  // If it's last year, 2% bonus
  if (seasonNumber === currentYear - 1) {
    return 2;
  }

  // Older seasons, no bonus
  return 0;
};
